import './AboutScreen.scss';

import React from 'react';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Copyable from 'src/component/UI/Copyable';
import { FormControl, FormLabel } from '@mui/material';
import { Link } from 'react-router-dom';

import { getClient } from 'src/module/authentication/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';


export default function AboutScreen () {
  const { t } = useTranslation();
  const client = useSelector(getClient);
  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page'>
      <Helmet>
        <title>{t('about.title')} {title}</title>
      </Helmet>

      <Grid className='settings-pane' item xs={6}>
        <Paper>
          <h2>{t('about.yourSite')}</h2>
          <div className='description'>{t('about.siteDetailsDescription')}</div>
          <FormControl fullWidth>
            <FormLabel>{t('common.name')}</FormLabel>
            <div className='value'><Copyable>{client.get('name')}</Copyable></div>
          </FormControl>
          <FormControl fullWidth>
            <FormLabel>{t('about.facilityId')}</FormLabel>
            <div className='value'><Copyable>{client.get('id')}</Copyable></div>
          </FormControl>
          <FormControl fullWidth>
            <FormLabel>{t('about.release')}</FormLabel>
            <div className='value'><Copyable>{import.meta.env.REACT_APP_FOX_RELEASE_HASH || 'N/A'}</Copyable></div>
          </FormControl>
        </Paper>
      </Grid>

      <Grid className='settings-pane' item xs={6}>
        <Paper>
          <h2>{t('about.legal')}</h2>
          <div className='description'>
            <span>&copy; 2021-{(new Date().getFullYear())} Chemelex Canada Ltd.</span><br/>
            <span>{t('about.allRightsReserved')}</span><br/>
            <a href='https://www.chemelex.com/en-us/chemelex/privacy-statement' target='_blank' rel='noopener noreferrer'>{t('about.privacyPolicy')}</a><br/>
            <a href='https://ehtgroup.com/legal/terms' target='_blank' rel='noopener noreferrer'>{t('auth.termsOfUse')}</a><br/>
            <Link to='/service-agreement'>{t('about.serviceAgreement')}</Link>
          </div>
        </Paper>
      </Grid>
    </div>
  );
}
